<template>
  <div id="app">
    <SvgHtml />
    <router-view v-wechat-title="$route.meta.title" /> 
  </div>
</template>

<script>

import SvgHtml from '@/components/SvgHtml.vue'

export default {
  name: 'App',
  components: {
    SvgHtml
  }
}
</script>

<style>
#app {
  font-size: 14px;
}
</style>
